import React from 'react';
import * as StyledHero from './hero.styles';
import Image from './image/image';
import { StyledNightThemeGradient } from '../base/decorative/nightThemeGradient';
import CtaApartmentFilters from '../ctaApartmentFilters/ctaApartmentFilters';

const Hero = ({
	title,
	text,
	imageUrl,
	imageRightSideOnly,
	url
}) => {
	return (
		<>
			<StyledNightThemeGradient />
			<StyledHero.Wrapper name="Wrapper" imageRightSideOnly={imageRightSideOnly}>
				<Image imageUrl={imageUrl} imageRightSideOnly={imageRightSideOnly} />
				<StyledHero.Content>
					<StyledHero.HeroTitle>
						{title}
					</StyledHero.HeroTitle>
					<StyledHero.HeroText>
						{text}
					</StyledHero.HeroText>
				</StyledHero.Content>
				<StyledHero.FiltersWrapper>
					<CtaApartmentFilters url={url} />
				</StyledHero.FiltersWrapper>
			</StyledHero.Wrapper>
		</>
	);
};

Hero.propTypes = {
};

Hero.defaultProps = {
};

export default Hero;
